import { types } from 'mobx-state-tree';

export const BrandModel = types.model({
    count: types.number,
    name: types.string,
    key: types.number,
    checked: types.maybe(types.boolean)
});
